(function () {
  var FORM_SCRIPT = 'product-form.js';
  var cache = {};
  var open = null;
  var closing = false;
  var hideTimer = null;
  var lastTrigger = null;
  var formScriptLoaded = false;

  function assetUrl(file) {
    var known = window.theme && window.theme.assets;
    if (file === FORM_SCRIPT && known && known.productForm) return known.productForm;
    var probe = document.querySelector('script[src*="/cdn/shop/"][src*="/assets/"], link[href*="/cdn/shop/"][href*="/assets/"]');
    var ref = probe ? probe.src || probe.href : '';
    var cut = ref.indexOf('/assets/');
    return cut === -1 ? '/' + file : ref.slice(0, cut + 8) + file;
  }

  function loadProductForm() {
    if (formScriptLoaded || window.customElements.get('product-form')) {
      formScriptLoaded = true;
      return Promise.resolve();
    }
    formScriptLoaded = true;
    return new Promise(function (resolve) {
      var s = document.createElement('script');
      s.src = assetUrl(FORM_SCRIPT);
      s.onload = resolve;
      s.onerror = resolve;
      document.head.appendChild(s);
    });
  }

  function fetchModal(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '?view=quick-add', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (r) {
        if (!r.ok) throw new Error('quick-add ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root = doc.querySelector('[data-quick-add-root]');
        if (!root) throw new Error('quick-add root missing');
        cache[handle] = root.outerHTML;
        return cache[handle];
      });
  }

  function focusables(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href], button:not([disabled]), select, input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])'),
      function (el) {
        return el.offsetParent !== null;
      }
    );
  }

  function onKeydown(event) {
    if (!open) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var items = focusables(open);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function destroy() {
    if (!open) return;
    clearTimeout(hideTimer);
    open.remove();
    open = null;
    document.body.classList.remove('w-scroll-lock');
    document.removeEventListener('keydown', onKeydown);
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger = null;
  }

  function close() {
    if (!open || closing) return;
    var root = open;
    closing = true;
    root.classList.remove('is-open');
    document.body.classList.remove('w-scroll-lock');
    document.removeEventListener('keydown', onKeydown);

    var trigger = lastTrigger;
    var finalize = function () {
      clearTimeout(hideTimer);
      if (open === root) {
        root.remove();
        open = null;
      }
      closing = false;
    };
    var panel = root.querySelector('[data-qa-panel]');
    if (panel) {
      panel.addEventListener('transitionend', finalize, { once: true });
      hideTimer = setTimeout(finalize, 400);
    } else {
      finalize();
    }

    if (trigger && document.contains(trigger)) trigger.focus();
    lastTrigger = null;
  }

  function mount(html) {
    destroy();
    var host = document.createElement('div');
    host.innerHTML = html;
    var root = host.firstElementChild;
    document.body.appendChild(root);
    open = root;
    closing = false;
    void root.offsetHeight;
    root.classList.add('is-open');
    document.body.classList.add('w-scroll-lock');
    document.addEventListener('keydown', onKeydown);

    root.addEventListener('click', function (event) {
      if (event.target === root) close();
      if (event.target.closest('[data-qa-close]')) close();
    });

    var panel = root.querySelector('[data-qa-panel]');
    if (panel) panel.focus();
  }

  function openFor(handle, trigger) {
    lastTrigger = trigger || null;
    if (trigger) trigger.setAttribute('aria-busy', 'true');
    Promise.all([loadProductForm(), fetchModal(handle)])
      .then(function (res) {
        mount(res[1]);
      })
      .catch(function () {
        window.location.href = '/products/' + encodeURIComponent(handle);
      })
      .finally(function () {
        if (trigger) trigger.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-quick-add]');
    if (!trigger) return;
    var handle = trigger.getAttribute('data-quick-add');
    if (!handle) return;
    event.preventDefault();
    openFor(handle, trigger);
  });

  document.addEventListener('cart:add', close);
})();
